"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cartReducer = exports.cartInitialState = void 0;
const types_1 = require("../types");
const utils_1 = require("../utils");
exports.cartInitialState = {
    cart: undefined,
    orderId: undefined,
    items: [],
    state: 'idle',
    totalItems: 0,
};
const cartReducer = (state = exports.cartInitialState, action) => {
    let newState = state;
    switch (action.type) {
        case types_1.CartActionTypes.ADD_ITEM:
            newState = Object.assign(Object.assign({}, state), { items: (0, utils_1.addOrIncrementItem)(state.items, action.item), state: 'idle' });
            (0, utils_1.saveCartItemsToLocalStorage)(newState.items);
            break;
        case types_1.CartActionTypes.REMOVE_ITEM:
            newState = Object.assign(Object.assign({}, state), { items: (0, utils_1.removeItem)(state.items, action.item.id) });
            (0, utils_1.saveCartItemsToLocalStorage)(newState.items);
            break;
        case types_1.CartActionTypes.UPDATE_ITEM_QUANTITY:
            newState = Object.assign(Object.assign({}, state), { items: (0, utils_1.updateItemQuantity)(state.items, action.item) });
            (0, utils_1.saveCartItemsToLocalStorage)(newState.items);
            break;
        case types_1.CartActionTypes.SET_CART_DATA:
            newState = Object.assign(Object.assign({}, state), { cart: action.item });
            if (newState.cart) {
                (0, utils_1.saveCartToLocalStorage)(newState.cart);
            }
            break;
        case types_1.CartActionTypes.SET_CART_ITEMS:
            newState = Object.assign(Object.assign({}, state), { items: action.item });
            (0, utils_1.saveCartItemsToLocalStorage)(newState.items);
            break;
        case types_1.CartActionTypes.SET_ORDER_ID:
            newState = Object.assign(Object.assign({}, state), { orderId: action.item, state: 'loaded' });
            break;
        case types_1.CartActionTypes.SET_STRATEGY:
            newState = Object.assign(Object.assign({}, state), { strategy: action.item });
            (0, utils_1.saveCartItemsToLocalStorage)(newState.items);
            break;
        case types_1.CartActionTypes.CLEAR_CART:
            newState = Object.assign(Object.assign({}, state), exports.cartInitialState);
            break;
        case types_1.CartActionTypes.LOADING_CART:
            newState = Object.assign(Object.assign({}, state), { state: 'loading' });
            break;
        case types_1.CartActionTypes.LOADED_CART:
            newState = Object.assign(Object.assign({}, state), { state: 'loaded' });
            break;
        case types_1.CartActionTypes.ERROR:
            newState = Object.assign(Object.assign({}, state), { state: 'error' });
            break;
        case types_1.CartActionTypes.SET_META_DATA:
            newState = Object.assign(Object.assign({}, state), { resellerData: action.item.reseller, cycleData: action.item.cycle, uf: action.item.uf });
            break;
        default:
            newState = state;
    }
    return Object.assign(Object.assign({}, newState), { totalItems: (0, utils_1.getTotalItemsByCart)(newState.items) });
};
exports.cartReducer = cartReducer;
